var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultOptionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 8.00004C12.0002 7.26366 12.5971 6.66671 13.3335 6.66671C14.0699 6.66671 14.6668 7.26366 14.6668 8.00004C14.6668 8.73642 14.0699 9.33337 13.3335 9.33337C12.5971 9.33337 12.0002 8.73642 12.0002 8.00004Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 8.00004C6.66683 7.26366 7.26378 6.66671 8.00016 6.66671C8.73654 6.66671 9.3335 7.26366 9.3335 8.00004C9.3335 8.73642 8.73654 9.33337 8.00016 9.33337C7.26378 9.33337 6.66683 8.73642 6.66683 8.00004Z",
    fill: "#1A1B1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 8.00004C1.3335 7.26366 1.93045 6.66671 2.66683 6.66671C3.40321 6.66671 4.00016 7.26366 4.00016 8.00004C4.00016 8.73642 3.40321 9.33337 2.66683 9.33337C1.93045 9.33337 1.3335 8.73642 1.3335 8.00004Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultOptionsIcon);
export default __webpack_public_path__ + "static/media/vault-options-icon.7001ccc58f4e129ffa71244442c7530a.svg";
export { ForwardRef as ReactComponent };